/*
 * File: zh-TW.ts
 * File Created: 2023-12-05 02:19:57
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2025-12-09 10:57:07
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { RegisterBaseLanguage } from "./core";
import { IBaseLang } from "./core";

@RegisterBaseLanguage("zh-TW", "正體中文")
export default class LangObject implements IBaseLang {
    /// generic terms //////////////////
    w_Description = "說明";
    w_Email = "電子信箱";
    w_Name = "名稱";
    w_Username = "使用者名稱";
    w_Password = "密碼";
    w_Index = "編號";
    w_Date = "日期";
    w_Id = "ID";
    w_Age = "年齡";
    w_CreatedAt = "建立日期";
    w_UpdatedAt = "更新日期";
    w_BeginAt = "開始日期";
    w_EndAt = "結束日期";
    w_Image = "圖片";
    w_Yes = "是";
    w_No = "否";
    w_On = "開";
    w_Off = "關";
    w_Reload = "重新整理";
    w_Unknown = "未知";
    w_Menu = "選單";
    w_Home = "首頁";
    w_Loading = "正在載入";
    w_Detail = "詳細";
    w_Role = "角色";
    w_RolePermission = "角色權限";
    w_IsEnabled = "是否啟用";
    w_Log = "日誌";
    w_Priority = "優先級";
    w_Category = "類別";
    w_ErrorMessage = "錯誤訊息";
    w_OtherMessage = "其他訊息";
    w_System = "系統";
    w_Status = "狀態";
    w_NICs = "網路介面";
    w_Manufacturer = "製造商";
    w_Brand = "品牌";
    w_Speed = "速度";
    w_Cores = "核心數";
    w_PhysicalCores = "物理核心數";
    w_Memory = "記憶體";
    w_Disks = "磁碟機";
    w_Device = "裝置";
    w_Type = "類別";
    w_SerialNumber = "序號";
    w_Actions = "動作";

    w_Common = "一般";
    w_NextPage = "下一頁";
    w_PreviousPage = "上一頁";
    w_Search = "搜尋";
    w_Browse = "瀏覽";
    w_NextStep = "下一步";
    w_PreviousStep = "前一步";
    w_Done = "完成";
    w_Save = "保存";
    w_Test = "測試";
    w_Success = "成功";
    w_Error = "錯誤";
    w_Language = "語言";
    w_Title = "標題";
    w_Every = "每";
    w_EveryMonth = "每月";

    w_Login = "登入";
    w_Logout = "登出";
    w_NewPassword = "新密碼";
    w_ConfirmChangePassword = "修改密碼?";
    w_LoginFailed = "登入失敗。";

    w_Add = "新增";
    w_Delete = "刪除";
    w_Edit = "修改";
    w_Export = "匯出";
    w_Import = "匯入";
    w_Info = "資訊";
    w_View = "檢視";
    w_More = "更多";

    w_Submit = "確定";
    w_Reset = "重置";
    w_Undo = "復原";

    w_Confirm = "確認";
    w_Cancel = "取消";
    w_Close = "關閉";
    w_ReLogin = "重新登入";
    w_Back = "返回";
    w_Finish = "完成";

    w_Upload = "上傳";
    w_Change = "更改";
    w_Remove = "移除";
    w_Abort = "中止";
    w_Retry = "重試";

    w_Second = "秒";
    w_Minute = "分";
    w_Hour = "時";
    w_Day = "日";
    w_Month = "月";
    w_Year = "年";

    w_Online = "上線";
    w_Offline = "離線";

    w_Enabled = "啟用中";
    w_Disabled = "已停用";

    // datetime
    w_Weekday = "星期";
    w_Time = "時間";
    w_DateTime_ShortWeekDay0 = "日";
    w_DateTime_ShortWeekDay1 = "一";
    w_DateTime_ShortWeekDay2 = "二";
    w_DateTime_ShortWeekDay3 = "三";
    w_DateTime_ShortWeekDay4 = "四";
    w_DateTime_ShortWeekDay5 = "五";
    w_DateTime_ShortWeekDay6 = "六";

    w_DateTime_NormalWeekDay0 = "星期日";
    w_DateTime_NormalWeekDay1 = "星期一";
    w_DateTime_NormalWeekDay2 = "星期二";
    w_DateTime_NormalWeekDay3 = "星期三";
    w_DateTime_NormalWeekDay4 = "星期四";
    w_DateTime_NormalWeekDay5 = "星期五";
    w_DateTime_NormalWeekDay6 = "星期六";

    w_DateTime_ShortMonth01 = "一月";
    w_DateTime_ShortMonth02 = "二月";
    w_DateTime_ShortMonth03 = "三月";
    w_DateTime_ShortMonth04 = "四月";
    w_DateTime_ShortMonth05 = "五月";
    w_DateTime_ShortMonth06 = "六月";
    w_DateTime_ShortMonth07 = "七月";
    w_DateTime_ShortMonth08 = "八月";
    w_DateTime_ShortMonth09 = "九月";
    w_DateTime_ShortMonth10 = "十月";
    w_DateTime_ShortMonth11 = "十一月";
    w_DateTime_ShortMonth12 = "十二月";

    w_DateTime_NormalMonth01 = "一月";
    w_DateTime_NormalMonth02 = "二月";
    w_DateTime_NormalMonth03 = "三月";
    w_DateTime_NormalMonth04 = "四月";
    w_DateTime_NormalMonth05 = "五月";
    w_DateTime_NormalMonth06 = "六月";
    w_DateTime_NormalMonth07 = "七月";
    w_DateTime_NormalMonth08 = "八月";
    w_DateTime_NormalMonth09 = "九月";
    w_DateTime_NormalMonth10 = "十月";
    w_DateTime_NormalMonth11 = "十一月";
    w_DateTime_NormalMonth12 = "十二月";

    w_DateTime_AM = "上午";
    w_DateTime_PM = "下午";
    ////////////////////////////////////

    /// for component used mb, put inside this block /////
    // iv-table
    w_ShowCurrentEntries = "顯示第 {curStart} 至 {curEnd} 筆，共 {total} 筆";
    w_ShowEntries = "顯示 {0} 筆資料";
    w_NoDataAvailable = "沒有資料";
    w_ConnectionError = "連線失敗";
    // iv-table-cell
    w_CellNullText = "無";
    // iv-input-file-classic
    w_IFCNoFileChosen = "沒有選擇檔案";
    // iv-input-tree-select
    w_PleaseSelect = "請選擇";
    w_InputTreeSelectNoAvailable = "沒有可用選項";
    // iv-input-file
    w_InputFileAddNew = "新增檔案";
    w_InputFileSelect = "選擇檔案";
    w_InputFileNoFile = "沒有檔案";
    w_InputFileNotImageHint = "其他類型檔案";
    w_InputFileHint = "拖曳檔案至此或 {0}瀏覽{1}";
    w_InputFileInvalidField = "包含無效檔案";
    w_InputFileWaitingForSize = "等待檔案大小";
    w_InputFileSizeNotAvailable = "檔案大小不可用";
    w_InputFileLoadError = "載入時發生錯誤";
    w_InputFileUploading = "正在上傳";
    w_InputFileUploadComplete = "上傳完成";
    w_InputFileUploadAborted = "上傳已取消";
    w_InputFileUploadError = "上傳時發生錯誤";
    w_InputFileRevertError = "刪除時發生錯誤";
    w_InputFileRemoveError = "刪除時發生錯誤";
    w_InputFileTapToCancel = "點擊取消";
    w_InputFileTapToRetry = "點擊重試";
    w_InputFileTapToUndo = "點擊即可復原";
    // iv-input-cron
    w_InputCronPlaceholder = "請選擇定時策略";
    w_InputCronSecondEvery = "每一秒";
    w_InputCronSecondCriteria = "從第{0}秒起每隔{1}秒";
    w_InputCronSecondSpecific = "第{0}秒";
    w_InputCronSecondBetween = "從{0}秒到{1}秒";
    w_InputCronMinuteEvery = "每一分鐘";
    w_InputCronMinuteCriteria = "從第{0}分鐘起每隔{1}分鐘";
    w_InputCronMinuteSpecific = "第{0}分鐘";
    w_InputCronMinuteBetween = "{0}到{1}之間的每一分鐘";
    w_InputCronHourEvery = "每一小時";
    w_InputCronHourCriteria = "從第{0}小時起每隔{1}小時";
    w_InputCronHourSpecific = "第{0}小時";
    w_InputCronHourBetween = "從{0}點到{1}點";
    w_InputCronDayEvery = "每一天";
    w_InputCronDayCriteria = "從每月第{0}天起每隔{1}天";
    w_InputCronDayOfWeek = "每星期{0}";
    w_InputCronDayOfMonth = "每月{0}號";
    w_InputCronDayLastDayOfMonth = "{w_EveryMonth}最後一天";
    w_InputCronDayLastWeekdayOfMonth = "{w_EveryMonth}最後一個工作日";
    w_InputCronDayLastDayOfWeek = "{w_EveryMonth}最後一個星期{0}";
    w_InputCronDayBeforeLastDayOfMonth = "{w_EveryMonth}倒數第{0}天";
    w_InputCronDayNearestWeekday = "{w_EveryMonth}最接近 {0} 號的下個工作日";
    w_InputCronDayNumberedDayOfWeek = "{w_EveryMonth}的第{0}個星期{1}";
    w_InputCronMonthEvery = "每一個月";
    w_InputCronMonthCriteria = "從第{0}個月開始每隔{1}個月";
    w_InputCronMonthSpecific = "特定月份{0}";
    w_InputCronMonthBetween = "從{0}月到{1}月";
    w_InputCronYearEvery = "每一年";
    w_InputCronYearCriteria = "從{0}年開始每隔{1}年";
    w_InputCronYearSpecific = "特定年份{0}";
    w_InputCronYearBetween = "從{0}年到{1}年";
    w_InputCronReadTextYear = "{0}年";
    w_InputCronReadTextMonth = "{0}月";
    w_InputCronReadTextDay = "{0}號";
    w_InputCronReadTextHour = "{0}時";
    w_InputCronReadTextMinute = "{0}分";
    w_InputCronReadTextSecond = "{0}秒";
    w_InputCronReadTextYearSp = "特定年份";
    w_InputCronReadTextMonthSp = "特定月份";
    w_InputCronReadTextDaySp = "特定日期";
    w_InputCronReadTextHourSp = "特定小時";
    w_InputCronReadTextMinuteSp = "特定分鐘";
    w_InputCronReadTextSecondSp = "特定秒數";
    w_InputCronReadTextYearEvery = "每年";
    w_InputCronReadTextMonthEvery = "每月";
    w_InputCronReadTextDayEvery = "每日";
    w_InputCronReadTextHourEvery = "每時";
    w_InputCronReadTextMinuteEvery = "每分";
    w_InputCronReadTextSecondEvery = "每秒";
    w_InputCronReadTextMonthOdd = "單數月";
    w_InputCronReadTextMonthEven = "雙數月";
    // iv-input-table
    w_InputTableConfirmDelete = "資料刪除確認";
    w_InputTableConfirmDeleteMessage = "是否確認刪除?";

    // iv-form
    w_RequiredField = "這是必要欄位";
    // iv-form-file
    w_FileExceedLimit = "檔案大小超過限制 ({limit})";
    // iv-form-password
    w_RequireValidPassword = "密碼需至少 {length} 個字元，包括大寫字母、小寫字母和符號";
    // iv-form-square-meter
    w_SquareMeter = "平方公尺";
    w_Tsubo = "坪";

    // ui-validate-unique
    w_FormUniqueStringValidating = "正在驗證...";
    w_FormUniqueStringValidated = "驗證通過";
    w_FormUniqueStringBeenUsed = `"{0}" 已經使用過`;
    // ui-validate-email
    w_RequireValidEmailFormat = "請輸入正確的 email 格式";
    // ui-validate-ip
    w_RequireValidIPFormat = "請輸入正確的 IP 格式";
    // ui-form-quick-table
    w_AutofillAfterCreate = "建立後自動代入";

    // http alert
    w_StatusUnknown = "請求失敗";
    w_StatusUnknown_Message = "伺服器沒有回應。";
    w_Status400 = "錯誤請求";
    w_Status400_Message = "客戶端錯誤，請檢查輸入資訊。";
    w_Status401 = "授權無效 / 連線逾時";
    w_Status401_Message =
        "系統無法驗證您的身分，或是連線已逾時。請重新登入以繼續使用系統服務。";
    w_Status403 = "權限不足";
    w_Status403_Message = "當前請求需要權限才能進行訪問。";
    w_Status404 = "請求不存在";
    w_Status404_Message = "此資源無法存取。";
    w_Status422 = "無法處理";
    w_Status422_Message =
        "請求格式正確，但由於語義錯誤無法被伺服器處理。請檢查輸入資訊的完整性或正確性。";
    w_Status500 = "內部伺服器錯誤";
    w_Status500_Message = "未知的伺服器錯誤。";
    /////////////////////////////////////////////////////

    w_FormMultipleClickToAdd = "點擊來新增資料";

    w_VersionLimitation = "版本限制";
    w_VersionNotEnough = "ServerFramework 版本需求應大於 v{version}。";
    w_PermissionDenied = "權限不足";
    w_PermissionDeniedLong = "您的權限無法訪問此區域。";
    w_ContentInvalid = "內容不存在";

    w_ConfirmDelete = "是否確定刪除?";
    w_FormSelectionNoResult = "無可用選項";
    w_NoFileChosen = "沒有選擇檔案";

    /// validation message
    w_ValidateRequireConsent = "需要同意才能繼續";
    w_ValidateRange = "(範圍： {min}-{max})";
    w_ValidateRangePercent = "(範圍： {min}-{max}%)";
    w_ValidationIp = "請輸入正確的 IP 格式。";
    w_ValidationLicense = "請輸入正確的 License 格式。";
    w_ValidationNumber = "請輸入範圍內的數字 ({min}-{max})。";
    w_ValidationEmail = "請輸入正確的 Email 格式。";
    w_ValidationImageFile =
        "副檔名必須為 .jpg / .jpeg / .png / .bmp，檔案大小必須小於 {0} MB";

    /// form-datetime
    w_Date_Not_Selected = "請選擇日期";
    w_Time_Not_Selected = "請選擇時間";

    /// theme
    w_VAL_Theme_White = "標準白";
    w_VAL_Theme_Blue = "標準藍";

    /// quick
    w_QuickList_ListItem = "{0}列表";
    w_QuickList_CreateItem = "建立{0}";
    w_QuickList_EditItem = "修改{0}";
    w_QuickList_DeleteItem = "刪除{0}";
    w_QuickList_TableEmpty = "沒有{0}";
    w_QuickList_Goto = "前往";
    w_QuickDetail_Title = "{0}內容";
    w_QuickDetail_ShowSimple = "簡易";
    w_QuickDetail_ShowDetail = "詳細";

    w_QuickCreate_BasicInformation = "基本資料";
    w_QuickCreate_UpdateInformation = "更新資訊";
}
